import React, { useEffect, useState } from 'react';

import { Stepper } from '@components/Stepper';
import { useEnabledSteps } from '@components/utilities/MembershipForm/helpers';
import { steps } from '@data/membershipForm';
import { AuthManager } from '@store/AuthManager';
import { observer } from 'mobx-react';

export interface EnabledStepsProps {
  onChange: (values: string[]) => void;
}

export const EnabledSteps: React.FC<EnabledStepsProps> = ({ onChange }) => {
  const enabledSteps = useEnabledSteps();
  useEffect(() => {
    onChange(enabledSteps);
  }, [JSON.stringify(enabledSteps)]);

  return null;
};

export interface ConnectedStepperProps {
  index: number;
}

export const ConnectedStepper: React.FC<ConnectedStepperProps> = observer(({ index }) => {
  const [enabledSteps, setEnabledSteps] = useState<string[]>([]);
  const authManager = AuthManager.shared;

  return (
    <>
      {authManager.isLoggedIn && <EnabledSteps onChange={setEnabledSteps} />}
      <Stepper enabledSteps={enabledSteps} steps={steps} value={steps[index].name} />
    </>
  );
});
